var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOnlineJobBagGlobe2 = function SvgOnlineJobBagGlobe2(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.778,
    y: 12.25,
    width: 16,
    height: 11,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 0.778,
    y1: 16.25,
    x2: 16.778,
    y2: 16.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 8.778,
    y1: 16.25,
    x2: 8.778,
    y2: 18.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.778,12.25h-6l.361-2.164a1,1,0,0,1,.986-.836h3.306a1,1,0,0,1,.987.836Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.273,6.428a6.5,6.5,0,1,1,9.27,6.679"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.722.75a8.723,8.723,0,0,0-2.663,7.482"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.722.75a8.563,8.563,0,0,1,2.708,6.5,9.294,9.294,0,0,1-.78,3.793"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 10.592,
    y1: 5.083,
    x2: 22.849,
    y2: 5.083
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 16.838,
    y1: 9.417,
    x2: 22.851,
    y2: 9.417
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOnlineJobBagGlobe2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "online-job-bag-globe-2.720acc2398a2654629603ad0214cca77.svg";